document.addEventListener("DOMContentLoaded", function() {
    // Select the container div with the unique class
    const blogContentContainer = document.querySelector(".article-template__content");
    if (blogContentContainer) {
        // Select all heading tags within the identified container
        const headings = blogContentContainer.querySelectorAll("h2, h3, h4, h5, h6");
        if(headings.length == 0){
          const table_head = document.querySelectorAll(".table_content");
            table_head.forEach(head => {
                head.classList.add("no_data");
            });       
        }
        const tocContainer = document.getElementById("table-of-contents");
        
        // Create an array to store all TOC links
        const tocLinks = [];

        headings.forEach((heading, index) => {
            // Create a unique ID for each heading if it doesn't already have one
            if (!heading.id) {
                heading.id = "heading-" + index;
            }
            
            // Create TOC link
            const link = document.createElement("a");
            link.classList.add("content-head");
            link.href = "#" + heading.id;
            link.textContent = heading.textContent.trim(); // Remove extra spaces, if any
            link.style.display = "block";

            // Add the link to the tocLinks array
            tocLinks.push(link);

            // Add active class to the first link by default
            if (index === 0) {
                link.classList.add("active");
            }

            // Add click event listener for toggling the active class and scrolling
            link.addEventListener("click", function (event) {
                // Remove active class from all links
                tocLinks.forEach(l => l.classList.remove("active"));
                
                // Add active class to the clicked link
                link.classList.add("active");

                // Scroll to the heading section smoothly
                document.getElementById(heading.id).scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });

                // Prevent default anchor behavior to avoid double-scrolling
                event.preventDefault();
            });

            // Append link to TOC container
            tocContainer.appendChild(link);
        });
    }
});
